/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef, history} from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import useFetchWithOutMsal from '../hooks/useFetchWithOutMsal';
import { protectedResources } from "../authConfig";
import { Navigate, useNavigate } from 'react-router-dom';
import { CheckPopUpContext } from '../components/DataContext';

export const RegistraDenuncia = () => {

    const { error, execute } = useFetchWithOutMsal({
    });

    const [tipoDoc, setTipoDoc] = useState([]);
    const [region, setRegion] = useState([]);
    const [origen, setOrigen] = useState([]);
    const [area, setArea] = useState([]);
    const [validated, setValidated] = useState(false);
    const [denuncia, setDenuncia] = useState({ data: "", message: "" });

    const [nombresApellidos, setNombresApellidos] = useState('');
    const [tipoDocumentoId, setTipoDocumentoId] = useState('');
    const [numDocumento, setNumDocumento] = useState('');
    const [telefono, setTelefono] = useState('');
    const [regionId, setRegionId] = useState('');
    const [correo, setCorreo] = useState('');
    const [origenId, setOrigenId] = useState('');
    const [areaId, setAreaId] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [archivoBase64, setArchivoBase64] = useState('');
    const [archivoBoleean, SetArchivoBoleean] = useState('');
    const [nombreArchivo, setNombreArchivo] = useState('');
    const emailRegexp = /^[^\s@]+@[^\s@]+\.[^\s@¡¿]+$/;
    const validacionCaracterEspecial = /["'/*%;$#:&()=¿?¡!@0-9]/;
    const validacionEspecialEmail= /["'/*%;$#:&()=¿?¡!]/;

    // Definir Variable con el Contexto del primer PopUp
    const checkPopUpContext = useContext(CheckPopUpContext);
    const opcionSeleccionadaPopUp1 = checkPopUpContext.opcionSeleccionadaPopUp1;

    // Definir Variable con el Contexto del primer PopUp
    const checkPopUpContext1 = useContext(CheckPopUpContext);
    const { opcionSeleccionadaPopUp2 } = checkPopUpContext1;

    // Definir Variable con el Contexto del primer PopUp
    const checkPopUpContext2 = useContext(CheckPopUpContext);
    const { tipoConductaSICOF } = checkPopUpContext2;

    const navigate = useNavigate();

    // useEffect(() => {
    //     // Solicitud Tipo GET a la API
    //     execute("GET", protectedResources.apiDenuncia.endpoint + 'api/tipodocumento').then((response) => {
    //         //Respues de la Solicitud 
    //         setTipoDoc(response)
    //     })

    //     execute("GET", protectedResources.apiDenuncia.endpoint + 'api/region').then((response) => {
    //         setRegion(response)
    //     })

    //     execute("GET", protectedResources.apiDenuncia.endpoint + 'api/origen').then((response) => {
    //         setOrigen(response)
    //     })

    //     execute("GET", protectedResources.apiDenuncia.endpoint + 'api/area').then((response) => {
    //         setArea(response)
    //     })

    //     execute("GET", protectedResources.apiDenuncia.endpoint + 'api/tipoconducta').then((response) => {
    //         //setTipoCondunctaSICOF(response)
    //     })
    // }, []);


    const handleSubmit = (event) => {
        console.log("Clickado")
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            configurarEstilosPopUp();
        } else {
            const registraDenuncia = {
                // nombres_apellidos: nombresApellidos,
                // tipo_documento_id: tipoDocumentoId,
                // numero_documento: numDocumento,
                // telefono: telefono,
                // correo: correo,
                // origen_id: origenId,
                // area_id: areaId,
                // tipo_conducta_id: tipoConductaSICOF,
                // region_id: regionId,
                // descripcion: descripcion,
                // archivo_base64: archivoBase64,
                // nombre_archivo: nombreArchivo,
                // check_registrar_denuncia: opcionSeleccionadaPopUp1,
                // check_protección_datos: opcionSeleccionadaPopUp2,
                // archivo_booleano: archivoBoleean
            };
            execute("POST", protectedResources.apiDenuncia.endpoint + 'api/registradenuncia', registraDenuncia)
                .then((response) => {
                    if (response.status === 'OK') {
                        console.log("Respuesta del servidor: ", response);
                        setDenuncia(response);
                        console.log(denuncia);
                        console.log("Se ha enviado el Formulario");
                    } else {
                        console.log("Respuesta del servidor: ", response);
                        setDenuncia({ data: "", message: "" });
                    }
                })
            // navigate('/DenunciaEnviada')
        }
        setValidated(true);

    };



    if (error) {
        return <div>Error: {error.message}</div>;
    };
    const handleArchivoChange = (event) => {
        const target = event.target;
        if (target.files.length > 0) {
            if (target.files[0].type !== "application/pdf") {
                alert("Solo se permiten archivos PDF");
                target.value = null;
                return;
            }
            if (target.files[0].size > 2e6) {
                target.value = null;
                alert("Solo se permiten archivos de un tamaño máximo de 2Mb");
                return;
            }
            var reader = new FileReader();
            reader.readAsDataURL(target.files[0]);
            reader.onload = function () {
                var base64 = reader.result;
                setArchivoBase64(base64.split(',')[1]);
            }
            setNombreArchivo(target.files[0].name);
            SetArchivoBoleean(true);
        }else{
            SetArchivoBoleean(false);
        }
    };

    const handleTipoDocChange = (event) => {
        setTipoDocumentoId(event.target.value);
    };

    const handleNumDocChange = (event) => {
        setNumDocumento(event.target.value);
    };

    const handleNombresApellidos = (event) => {
        const divError = document.getElementById('errorNombreApellidos');
        const feedbackFormControl = document.getElementById('feedbackNombreApellidos');
        var input = document.getElementById('inputnombresApellidos');

        if (input.value.trim() !== "") {
            feedbackFormControl.innerHTML = "";
        } else {
            feedbackFormControl.innerHTML = "Digite su Nombre Completo.";
        }

        if (validacionCaracterEspecial.test(input.value)) {
            if (validacionCaracterEspecial.test(input.value)) {
                if (/[0-9]/.test(input.value)) {
                    // Si el valor ingresado contiene un número
                    if (divError) {
                        divError.textContent = 'No se admiten números en este campo';
                        divError.style.color = '#dc3545';
                        divError.style.fontSize = '.850em';
                        divError.style.fontFamily = 'Raleway';
                        divError.style.display = 'block';
                        divError.style.paddingBottom = '-10px';
                    }
                } else {
                    // Si el valor ingresado contiene caracteres especiales pero no números
                    if (divError) {
                        divError.textContent = 'No se admiten caracteres especiales';
                        divError.style.color = '#dc3545';
                        divError.style.fontSize = '.850em';
                        divError.style.fontFamily = 'Raleway';
                        divError.style.display = 'block';
                        divError.style.paddingBottom = '-10px';
                    }
                }
            }
        } else {
            if (divError) {
                divError.textContent = '';
                divError.style.display = 'none';
                setNombresApellidos(input.value);
            }
        }
    };

    const handleTelefonoChange = (event) => {
        setTelefono(event.target.value);
    };

    const handleRegionChange = (event) => {
        setRegionId(event.target.value);
    };


    const handleCorreoChange = (event) => {
        const divError = document.getElementById('errorEmail')
        const feedbackFormControl = document.getElementById('feedback');
        var input = document.getElementById('inputCorreo');

        if (input.value.trim() !== "") {
            feedbackFormControl.innerHTML = "";
        }
        else {
            feedbackFormControl.innerHTML = "Digite un correo electrónico válido.";
        };

        if (validacionEspecialEmail.test(event.target.value)) {

            if (divError) {
                divError.textContent = 'Naao se admiten caracteres especiales';
                divError.style.color = '#dc3545';
                divError.style.fontSize = '.875em';
                divError.style.fontFamily = 'Raleway';
                divError.style.display = 'block';
            }
        } else {
            if (divError) {
                divError.textContent = '';
                divError.style.display = 'none';
                setCorreo(event.target.value);
            }
        }
    };

    const handleOrigenChange = (event) => {
        setOrigenId(event.target.value);
    };

    const handleAreaChange = (event) => {
        setAreaId(event.target.value);
    };

    const handleDescripcionChange = (event) => {
        setDescripcion(event.target.value);
    };

    const handleValidateNumDoc  = (event) => {
        const hasError = !emailRegexp.test(event.target.value);
        event.target.validated = false;
    };

    const configurarEstilosPopUp = () => {
        const MostrarPopUpRegistroFallido = document.getElementById("RegistroDenunciaFallidoSICOF");
        MostrarPopUpRegistroFallido.style.width = '30%';
        MostrarPopUpRegistroFallido.style.display = 'flex';
        MostrarPopUpRegistroFallido.style.flexDirection = 'column';
        MostrarPopUpRegistroFallido.style.position = 'absolute';
        MostrarPopUpRegistroFallido.style.flexWrap = 'wrap'; 
        MostrarPopUpRegistroFallido.style.alignItems = 'center'; 
        MostrarPopUpRegistroFallido.style.justifyContent = 'center';
        MostrarPopUpRegistroFallido.style.zIndex = 1;
        MostrarPopUpRegistroFallido.style.color = 'red';
        MostrarPopUpRegistroFallido.style.left = '35%';
        MostrarPopUpRegistroFallido.style.backgroundColor = 'white';
    
        // Agregar evento de clic al botón "Aceptar" para cerrar el pop-up
        document.getElementById("cerrarBtn").addEventListener("click", CerrarPopUp);
    };
    
    const CerrarPopUp = () => {
        const popUp = document.getElementById("RegistroDenunciaFallidoSICOF");
        popUp.style.display = "none";
    };


    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit} >
            <div className="markup">
                <h1>Registro de Denuncia</h1>
                <p>En el siguiente formulario por favor describe la situación de la manera más detallada posible.<br></br>
                    *Campos de diligenciamiento obligatorio.</p>
                <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Select name='tipo_documento_id' onChange={handleTipoDocChange} required>
                            <option className="d-none" value="">
                                Seleccione el tipo de Identificación *
                            </option>
                            {tipoDoc.map((option) => {
                                return (
                                    <option key={option.id} value={option.id}>
                                        {option.nombre}
                                    </option>
                                );
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Seleccione un tipo de identificación.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                <Col sm="10">
                        <Form.Control required name='numero_documento' onChange={handleNumDocChange} onBlur={handleValidateNumDoc} type="number" min={9999999999} max={999999999999999} placeholder="Número de identificación *" />
                        <Form.Control.Feedback type="invalid" >
                            Digite un número de identificación.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                <Col sm="10">
                    <Form.Control required name='nombres_Apellidos' onChange={handleNombresApellidos} type="text" placeholder="Nombres y Apellidos *" id='inputnombresApellidos' pattern='[a-zA-ZáéíóúiÁÉÍÓÚñÑ\s]+' maxlength="100" />
                        <Form.Control.Feedback type="invalid" id='feedbackNombreApellidos'>
                            Digite Los Nombres y Apellidos
                        </Form.Control.Feedback>
                        <div className='Error' id='errorNombreApellidos'></div>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Control required name='telefono' onChange={handleTelefonoChange} type="number" min={9999999999} max={999999999999999} placeholder="Teléfono *"  />
                        <Form.Control.Feedback type="invalid">  
                            Digite el Numero de Teléfono
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                <Col sm="10">
                        <Form.Control required name='correo' onChange={handleCorreoChange} type="email" placeholder="Correo electrónico *"  maxLength={100} id='inputCorreo' />
                        <Form.Control.Feedback type="invalid" id='feedback' >
                            Digite un correo electrónico valido.
                        </Form.Control.Feedback>
                        <div className='Error' id='errorEmail' ></div>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Select required name='origen_id' onChange={handleOrigenChange}>
                            <option className="d-none" value="">Origen de denuncia *</option>
                            {origen.map((option) => {
                                return (
                                    <option key={option.id} value={option.id}>
                                        {option.nombre}
                                    </option>
                                );
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Seleccione el Origen de denuncia.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                <Col sm="10">
                        <Form.Select required name='region_id' onChange={handleRegionChange}>
                            <option className="d-none" value="" placeholder='Departamento'>Departamento *</option>
                            {region.map((option) => {
                                return (
                                    <option key={option.id} value={option.id}>
                                        {option.nombre}
                                    </option>
                                );
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Seleccione el Departamento.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Select name='area_id' onChange={handleAreaChange} required>
                            <option className="d-none" value="">Área o Negocio Involucrado</option>
                            {area.map((option) => {
                                return (
                                    <option key={option.id} value={option.id}>
                                        {option.nombre}
                                    </option>
                                );
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Seleccione un Área o Negocio Involucrado.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Control required name='descripcion' onChange={handleDescripcionChange} as="textarea" placeholder="Descripción de los hechos * Máximo 1500 Caracteres" rows={8} maxLength={1500}/>
                        <Form.Control.Feedback type="invalid">
                            Digite la descripción de los hechos.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group  as={Row} className="mb-3">
                    <Col sm="10">
                        <Form.Control style={{}} name='archivo' onChange={handleArchivoChange} accept="application/pdf" type="file" placeholder="Adjuntar Archivo" />
                        <Form.Text muted >
                            Tamaño del archivo: 2 Mb Las evidencias deben remitirse escaneadas en formato.pdf
                        </Form.Text>
                    </Col>
                </Form.Group>

                <br />
                <div className="App-button">
                    <Button variant="primary" type="submit"> 
                        Enviar Formulario
                    </Button>
                </div>
                <br />
            </div>    

            <div id='RegistroDenunciaFallidoSICOF'>
                {/* <h2>No se ha Enviado El Formulario</h2> */}
                <p>Debe diligenciar todos los campos para poder continuar</p>
                <Button id="cerrarBtn">Aceptar</Button>
            </div>

            <div className='parteIzquierdaHeader'>
                    <div>
                        <h2>Canal Ético de Denuncias</h2>
                        <div className='detalles'></div>
                    </div>
                </div>
        </Form>

    );
};
